import type { AiThinkingStepEvent } from '../hooks/useConversationRealtimeSubscription';

const isAiThinkingRunStartStep = (step: string): boolean => {
  const normalized = step.trim().toLowerCase();
  return normalized === 'start'
    || normalized === 'entry'
    || normalized.endsWith('.start')
    || normalized.endsWith('.entry');
};

export const appendAiThinkingStepHistory = (
  current: AiThinkingStepEvent[],
  event: AiThinkingStepEvent,
): AiThinkingStepEvent[] => {
  const previousRunId = current.length > 0 ? current[current.length - 1].runId : null;
  const startedNewRun = Boolean(event.runId)
    && Boolean(previousRunId)
    && event.runId !== previousRunId;

  const next = startedNewRun || isAiThinkingRunStartStep(event.step)
    ? [event]
    : [...current, event];

  return next.length > 60 ? next.slice(next.length - 60) : next;
};